module.exports = __webpack_public_path__ + "img/fa4.7f95e6f2.jpg";